import {createAction} from '@ngrx/store';

export const increase = createAction('[Request Count] Increase');
export const decrease = createAction('[Request Count] Decrease');
